import { render, staticRenderFns } from "./Agent.vue?vue&type=template&id=f378bdae&scoped=true"
import script from "./Agent.vue?vue&type=script&lang=js"
export * from "./Agent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f378bdae",
  null
  
)

export default component.exports